import { mapState } from 'vuex'
import { trackEvent } from '@/analytics/track'

export default {
  computed: {
    ...mapState(['globalSubscriptionCheck', 'oneClickFromContext', 'petition', 'tryOneClickFromCrm'])
  },

  mounted() {
    if (this.oneClickFromContext) {
      // We're showing the one-click signing experience because the user is
      // logged in or has recently taken action.
      trackEvent('Saw petition prefill signature', {
        action: 'prefill-signature',
        category: 'petition',
        name: this.petition.slug,
        petition: this.petition.slug
      })
    }

    if (this.tryOneClickFromCrm) {
      this.$store.dispatch('fetchOneClickDataFromCrm')
    } else if (this.globalSubscriptionCheck.enabled) {
      this.$store.dispatch('fetchGlobalSubscriptionDataFromCrm')
    }
  }
}
